module.exports = __webpack_public_path__ + "img/tile-keyframes-desktop_jp.27cf1d2.jpg";